import PropTypes from 'prop-types';
const placeholders = {
  'es-pa': {
    name: 'Escriba una dirección',
    location: {
      lat: 8.962449,
      lng: -79.555363,
    }
  },
  'es-cr': {
    name: 'Escriba una dirección',
    location: {
      lat: 9.9359283,
      lng: -84.1002877,
    }
  },
  'es-hn': {
    name: 'Escriba una dirección',
    location: {
      lat: 14.1000382,
      lng: -87.2065637,
    }
  },
  'es-gt': {
    name: 'Escriba una dirección',
    location: {
      lat: 14.557312,
      lng: -90.734223,
    }
  },
  'es-ni': {
    name: 'Escriba una dirección',
    location: {
      lat: 12.236640,
      lng: -86.430755,
    }
  },
  'es-sv': {
    name: 'Escriba una dirección',
    location: {
      lat: 13.962736,
      lng: -89.185246,
    }
  }
}
const placeholderAutocomplete = (language) => {
  return placeholders[language];
}
placeholderAutocomplete.protoTypes = {
  language: PropTypes.string
}
export default placeholderAutocomplete;